export default __webpack_public_path__ + "static/media/TTCommons-ExtraBold.17db5b7c.woff";